import {
  COMPUTED_OPERATION_TYPES,
  CURRENCY_COUNTRY_CODE,
  FIELD_TYPES,
} from '../../../utility/constants'
import { getFieldId } from './utils'
export const CURRENCY_ERROR = 'ERR'

// return numeric field id
const getParamId = (param, isPolarized) => {
  return isPolarized
    ? +param.substring(3, param.indexOf('.'))
    : +param.substring(2, param.indexOf('.'))
}

// Important: This is old one and has been deprecated.
export const computeCurrencyOld = (fieldCurrencyMap, fields, defaultCurrency, allValuesUpdated) => {
  const nonDefaultValues = []
  let updatedFieldCurrencyMap = { ...fieldCurrencyMap }

  // auto compute currency fields
  const currencyFields = fields?.filter(
    (field) => field.data_structure === FIELD_TYPES.CURRENCY && field?.is_computed
  )

  // extra loop for finding the currency recursively for multiple level dependency
  currencyFields?.forEach((_) => {
    // finding currency of computed field
    currencyFields?.forEach((field) => {
      const params = field?.metadata?.params

      const isPolarityAppended = [
        COMPUTED_OPERATION_TYPES.SUM,
        COMPUTED_OPERATION_TYPES.MULTIPLY,
      ].includes(field?.metadata?.operation)

      const currencyParamFieldIds = params
        ?.filter((param) => param?.startsWith('^^'))
        ?.filter((param) => {
          const paramField = fields.find((field) => {
            return field.id === getParamId(param, isPolarityAppended)
          })

          if (!paramField?.is_subfield) {
            return allValuesUpdated[getFieldId(paramField?.id)] !== 0
          } else {
            return paramField?.data_structure === FIELD_TYPES.CURRENCY
          }
        })
        .map((it) => getParamId(it, isPolarityAppended))

      // filtering out non currency fields and calculating currency for computed currency field
      const currencies = currencyParamFieldIds.map(
        (it) => updatedFieldCurrencyMap[it] || CURRENCY_COUNTRY_CODE[defaultCurrency]
      )

      const isSame = currencies.every((val, _, arr) => val === arr[0])

      if (isSame) {
        // add to non_default_currency only if currency is same but not company's default
        if (currencies.length > 0 && currencies[0] != CURRENCY_COUNTRY_CODE[defaultCurrency]) {
          nonDefaultValues.push({
            id: field.id,
            currency: currencies[0] || CURRENCY_COUNTRY_CODE[defaultCurrency],
          })
        }

        updatedFieldCurrencyMap = {
          ...updatedFieldCurrencyMap,
          [field.id]: currencies[0] || CURRENCY_COUNTRY_CODE[defaultCurrency],
        }
      } else {
        nonDefaultValues.push({
          id: field.id,
          currency: '?',
        })
      }
    })
  })

  return { updatedFieldCurrencyMap, nonDefaultValues }
}

// Rewritten
export const computeCurrency = (fieldCurrencyMap, fields, defaultCurrency) => {
  const nonDefaultValues = []
  let updatedFieldCurrencyMap = { ...fieldCurrencyMap }

  // auto compute currency fields
  const currencyFields = fields?.filter(
    (field) =>
      field.data_structure === FIELD_TYPES.CURRENCY &&
      field?.is_computed &&
      field.metadata.operation != COMPUTED_OPERATION_TYPES.SUM_ACROSS_PROCESS // this computation happens in backend when importing
  )

  // id field map
  const idFieldMap = fields.reduce((acc, cur) => ({ ...acc, [cur.id]: cur }))

  // Computation Level - 2
  currencyFields?.forEach((_) => {
    // Computation Level - 1
    currencyFields?.forEach((field) => {
      const isPolarityAppended = [
        COMPUTED_OPERATION_TYPES.SUM,
        COMPUTED_OPERATION_TYPES.MULTIPLY,
      ].includes(field?.metadata?.operation)

      const params = field?.metadata?.params
      const paramFields = params
        ?.map((it) => idFieldMap[getParamId(it, isPolarityAppended)])
        .filter((it) => it != null)

      if (field.metadata?.operation === COMPUTED_OPERATION_TYPES.SUM) {
        // all param field needs to be currency and all fields must have same currency
        // find the current and set in updatedFieldCurrencyMap

        const isAllCurrency = paramFields.every((it) => it?.data_structure === FIELD_TYPES.CURRENCY)
        const paramsCurrency = paramFields
          .map((it) => updatedFieldCurrencyMap[it.id])
          .map((it) => (it === undefined ? CURRENCY_COUNTRY_CODE[defaultCurrency] : it)) // this will assign currency field as company's default currency.
        const isAllCurrencyAreSame = paramsCurrency.every((cur) => cur === paramsCurrency[0])

        if (isAllCurrency && isAllCurrencyAreSame) {
          updatedFieldCurrencyMap[field.id] =
            paramsCurrency[0] || CURRENCY_COUNTRY_CODE[defaultCurrency]

          // add to non_default_currency only if currency is same but not company's default
          if (updatedFieldCurrencyMap[field.id] !== CURRENCY_COUNTRY_CODE[defaultCurrency]) {
            nonDefaultValues.push({
              id: field.id,
              currency: paramsCurrency[0],
            })
          }
        } else {
          updatedFieldCurrencyMap[field.id] = '?'

          nonDefaultValues.push({
            id: field.id,
            currency: '?',
          })
        }
      } else if (field.metadata?.operation === COMPUTED_OPERATION_TYPES.MULTIPLY) {
        // one param field will be currency and others must be number
        // find the currency of currency field and set in updatedFieldCurrencyMap

        const hasOneCurrencyField =
          paramFields.filter((it) => it.data_structure === FIELD_TYPES.CURRENCY)?.length === 1

        const currencyField = paramFields.filter(
          (it) => it.data_structure === FIELD_TYPES.CURRENCY
        )[0]

        if (hasOneCurrencyField && currencyField) {
          updatedFieldCurrencyMap[field.id] =
            updatedFieldCurrencyMap[currencyField.id] || CURRENCY_COUNTRY_CODE[defaultCurrency]

          // add to non_default_currency only if currency is same but not company's default
          if (updatedFieldCurrencyMap[field.id] !== CURRENCY_COUNTRY_CODE[defaultCurrency]) {
            nonDefaultValues.push({
              id: field.id,
              currency: updatedFieldCurrencyMap[currencyField.id],
            })
          }
        } else {
          updatedFieldCurrencyMap[field.id] = '?'

          nonDefaultValues.push({
            id: field.id,
            currency: '?',
          })
        }
      } else if (field.metadata?.operation === COMPUTED_OPERATION_TYPES.SUM_TABLE_COLUMN) {
        // there will be only one currency field param
        // find the currency of currency field and set in updatedFieldCurrencyMap

        const hasOneCurrencyField =
          paramFields.filter((it) => it.data_structure === FIELD_TYPES.CURRENCY)?.length === 1

        const currencyField = paramFields.filter(
          (it) => it.data_structure === FIELD_TYPES.CURRENCY
        )[0]

        if (hasOneCurrencyField && currencyField) {
          updatedFieldCurrencyMap[field.id] =
            updatedFieldCurrencyMap[currencyField.id] || CURRENCY_COUNTRY_CODE[defaultCurrency]

          // add to non_default_currency only if currency is same but not company's default
          if (updatedFieldCurrencyMap[field.id] !== CURRENCY_COUNTRY_CODE[defaultCurrency]) {
            nonDefaultValues.push({
              id: field.id,
              currency: updatedFieldCurrencyMap[currencyField.id],
            })
          }
        } else {
          updatedFieldCurrencyMap[field.id] = '?'

          nonDefaultValues.push({
            id: field.id,
            currency: '?',
          })
        }
      } else if (field.metadata?.operation === COMPUTED_OPERATION_TYPES.SUM_ACROSS_PROCESS) {
        // IMPORTANT: NO NEED TO CALCULATE CURRENCY OF SUM_ACROSS_FIELD AS IT WILL BE DERIVED FROM OTHER ASSOCIATED PROCESS
      } else {
        if (updatedFieldCurrencyMap[field.id] === undefined) {
          updatedFieldCurrencyMap[field.id] = CURRENCY_COUNTRY_CODE[defaultCurrency]
        }
      }
    })
  })

  return { nonDefaultValues, updatedFieldCurrencyMap }
}

export const formatCurrency = (
  value,
  currencyCode,
  options = { locale: 'en-IN', defaultCurrency: 'INR' }
) => {
  const { locale, defaultCurrency } = options

  const finalCurrency = currencyCode === 'ERR' ? defaultCurrency : currencyCode || defaultCurrency

  let numericValue = parseFloat(value)
  if (!isFinite(numericValue)) {
    numericValue = 0.0
  }

  try {
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: finalCurrency,
    })

    return formatter.format(numericValue)
  } catch (error) {
    return `?0.00`
  }
}
